import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../service/auth/auth.service";
import {BenefitService} from "../../../service/benefit/benefit.service";
import {Category, BenefitBoard} from "app/service/benefit/benefit";

import {GtmService} from "../../../service/gtm/gtm.service";
import {DatePipe} from "@angular/common";
import {QuillConfigService} from "../../../service/quill/quill.service";
import {ImageUploadService} from "../../../service/image/image.service";

@Component({
  selector: 'app-benefit-detail',
  templateUrl: './benefit-detail.component.html',
  styleUrls: ['./benefit-detail.component.scss'],
  providers: [BenefitService, DatePipe, QuillConfigService, ImageUploadService]
})
export class BenefitDetailComponent{
  public updating: boolean = false;
  board: BenefitBoard;
  id: number;
  categories: Category[];

  constructor(private benefitService: BenefitService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
              private quillService: QuillConfigService,
              private imageService: ImageUploadService,
              private gtmService: GtmService,
              private datePipe: DatePipe) {


    this.benefitService.getCategories().subscribe(
      (categories) => this.categories = categories
    )

    this.route.params.subscribe(params => {
      this.id = params['id'] ? +params['id'] : null;

      if (this.id) {
        this.benefitService.get(this.id).subscribe(board => {
          this.updating = false;
          this.board = board;
          this.board.categoryName = this.board.category.name
          this.board.category = this.board.category.id;

          this.gtmService.pageViewWithPage({
            'path': this.route.snapshot['_routerState'].url,
            'title': board.name,
            'breadcrumb': 'Home > Member > Benefit'
          });
        });
      } else {
        this.updating = true;
        this.board = new BenefitBoard();
        this.board.category = '';

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': '글쓰기',
          'breadcrumb': 'Home > Member > Benefit'
        });
      }
    });
  }

  onUpdate(board: BenefitBoard) {
    if (!board.name) {
      window.alert('제휴사명을 입력해 주세요.');
      return;
    } else if (!board.category) {
      window.alert('제휴 분야를 선택해 주세요.');
      return;
    } else  if (!board.benefits) {
      window.alert('혜택을 입력해 주세요.');
      return;
    } else if (!board.logoImg) {
      window.alert('제휴사 로고를 등록해 주세요.');
      return;
    } else if (!board.introduce) {
      window.alert('제휴사 소개를 입력해 주세요.');
      return;
    }

    if(this.id) board.id = this.id;
    if(board.category) board.category = {id: board.category}

    this.benefitService.save(board).subscribe(
        res => {
          this.updating = false;
          this.board = { ...board, ...res, };
          this.board.categoryName = res.category.name
          this.board.category = res.category.id;

          window.scrollTo(0, 0);
          this.router.navigateByUrl(`/member/benefit/${res.id}`);
        }
      );
  }
  onDelete() {
    if (window.confirm('삭제 하시겠습니까?')) {
      this.benefitService.delete(this.id).subscribe(
        board => this.router.navigateByUrl('/member/benefit')
      );
    }
  }
  onClickUpdate() {
    window.scrollTo(0, 0);
    this.updating = true;
  }
  onClickBack() {
    window.scrollTo(0, 0);
    this.updating = false;
  }

  public editor;
  onEditorCreated(quill) {
    this.editor = quill;

    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('image', this.imageHandler.bind(this));
  }
  imageHandler() {
    const Imageinput = document.createElement('input');
    Imageinput.setAttribute('type', 'file');
    Imageinput.setAttribute('accept', 'image/png, image/gif, image/jpeg');
    Imageinput.classList.add('ql-image');

    Imageinput.addEventListener('change', () =>  {
      const file = Imageinput.files;
      this.imageService.makeFileRequest('/api/file-uploads', file).then(
        (result) => {
          this.pushImageToEditor(result['filename']);
        },
      )
    });

    Imageinput.click();
  }
  pasteHandler(imageDataUrl, type, imageData) {
    const file = imageData.toFile('paste.png')
    this.imageService.makeFileRequest('/api/file-uploads', [file]).then(
      (result) => {
        this.pushImageToEditor(result['filename']);
      },
    )
  }
  get pasteImageHandler() {
    return this.pasteHandler.bind(this)
  }
  
  pushImageToEditor(src) {
    const range = this.editor.getSelection(true);
    const index = range.index + range.length;
    this.editor.insertEmbed(range.index, 'image', src);
  }

  isMine(email: string): boolean {
    return this.authService.getEmail() == email;
  }


  onCanUpdate(): boolean {
    return !this.updating && !!this.board
      // && (this.board.author.email == this.authService.getEmail() || this.authService.isAdmin());
  }
}



// WEBPACK FOOTER //
// ./src/app/member/benefit-board/benefit-detail/benefit-detail.component.ts